export default class Nav {
  constructor(el) {
    this.DOM = { el: el };
    this.DOM.marker = document.querySelector('#js-nav-marker');
    this.state = {};
    this.state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    this.toggleView = this.toggleView.bind(this);

    this.init();
  }

  init() {
    if (!this.DOM.el) return;
    this.state.markerOffset = this.DOM.marker.offsetTop;
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', this.toggleView);
  }

  toggleView() {
    this.state.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.DOM.el.classList.toggle('nav-responsive--sticky', this.state.scrollTop > this.state.markerOffset);
  }
}